<mat-toolbar>
  <span>Angular Material Facet Search: v{{version}}</span>
  <span class="spacer"></span>
  <a mat-button routerLink="" [color]="showPageTwo ? 'primary' : ''">
    Page One
  </a>
  <a mat-button routerLink="/two" [color]="showPageOne ? 'primary' : ''">
    Page Two
  </a>
  <span class="spacer"></span>
  <a [href]="repo" target="_blank" mat-stroked-button>View on GitHub</a>
</mat-toolbar>

<div fxLayout="column" class="container">
  <router-outlet></router-outlet>
</div>
